import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  linkTo?: string;
  linkLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  linkTo,
  linkLabel = '查看全部',
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-3 border-b border-background-300/70 pb-4 sm:flex-row sm:items-end sm:justify-between md:mb-8">
      <div className="max-w-2xl">
        {eyebrow ? (
          <p className="mb-2 font-label text-xs uppercase tracking-[0.28em] text-primary-600">
            {eyebrow}
          </p>
        ) : null}
        <h2 className="font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
          {title}
        </h2>
        {description ? (
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">{description}</p>
        ) : null}
      </div>
      {linkTo ? (
        <Link
          to={linkTo}
          className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap font-label text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          {linkLabel}
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-line" />
          </span>
        </Link>
      ) : null}
    </div>
  );
}